import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Lock, AlertCircle } from 'lucide-react';

function ModuleNotAvailable({ moduleName }) {
  return (
    <div className="flex items-center justify-center min-h-[60vh] p-6">
      <Card className="max-w-md w-full">
        <CardHeader>
          <div className="flex items-center justify-center mb-4">
            <div className="rounded-full bg-yellow-100 p-4">
              <Lock className="w-12 h-12 text-yellow-600" />
            </div>
          </div>
          <CardTitle className="text-center">Module non disponible</CardTitle>
          <CardDescription className="text-center">
            Ce module n'est pas activé pour votre établissement
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-start space-x-3">
              <AlertCircle className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
              <div className="text-left text-sm text-blue-800">
                <p className="font-semibold mb-2">Pour activer ce module :</p>
                <ol className="list-decimal list-inside space-y-1">
                  <li>Contactez votre administrateur</li>
                  <li>Demandez l'activation du module {moduleName}</li>
                  <li>Ou mettez à niveau votre abonnement</li>
                </ol>
              </div>
            </div>
          </div>
          
          <p className="text-sm text-gray-600">
            Les modules supplémentaires permettent d'accéder à des fonctionnalités avancées adaptées aux besoins de votre établissement.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}

export default ModuleNotAvailable;
